import(/* webpackMode: "eager", webpackExports: ["PaymentDaysProvider"] */ "/app/app/providers/PaymentDaysProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/providers/RecaptchaProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/Accordion/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/AfaBreadcrumbs/breadcrumbs.module.css");
;
import(/* webpackMode: "eager" */ "/app/components/AfaForms/AccessibilityForm/AccessibilityForm.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/AfaForms/CalculateFPTForm/CalculateFPTForm.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/AfaForms/ComplaintsForm/ComplaintsForm.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/AfaForms/ContactForm/ContactForm.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/AfaForms/KRWebForm/KRWebForm.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/AfaForms/NewsletterForm/NewsletterForm.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/AfaForms/TestpanelForm/TestpanelForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ChatBoxComponents/InsurancePickerBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","Breadcrumb"] */ "/app/components/client/Breadcrumbs/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/client/Grid/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactBlock"] */ "/app/components/ContactBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactUsBlock"] */ "/app/components/ContactUsBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/FAQList/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/FileBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/FileList/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/ImageBlock/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/Link/ContentLink/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/Link/StandardLink/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/OrderBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Page/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/PageList/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/PaymentDaysBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/PersonalizationBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/QuizBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/SectionBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ShortCutsBlock/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/TableBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/TeaserBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackingPageInfoUpdater"] */ "/app/components/Tracking/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/VideoBlock/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/app/node_modules/nuqs/dist/adapters/next/app.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/node_modules/react-error-boundary/dist/react-error-boundary.js");
